import React from "react"

const days=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
export default function CurrentDate(props){
    
     const date=new Date(props.dateTime*1000)
      const day=date.getDay()
      let hours=date.getHours()
      if (hours<10){
        hours=`0${hours}`
      }
      let minutes=date.getMinutes()
      if(minutes < 10 ){
        minutes=`0${minutes}`}
      const dateDisplay=`${days[day]} ${hours} : ${minutes}`
      
    return(
        <div>
            {dateDisplay}
        </div>
    )}